import { isNumber } from '../../../util/guards';
import { SEARCH_LIMIT } from '../../common/reducers/solutions';
import { ArticleBiData, BlockId, blockNames, BlockType, SolutionInfo, SupportType } from '../types';

export function createSearchResultsSolutionInfo(
  articles: ArticleBiData[],
  text?: string,
  position?: number,
): SolutionInfo {
  const limitStartIndex = articles.length > SEARCH_LIMIT ? articles.length - SEARCH_LIMIT : 0;
  const positionStartCount = isNumber(position) ? position : limitStartIndex;

  return {
    block_id: BlockId.SearchResults,
    block_name: blockNames[BlockId.SearchResults],
    block_position: 1, // for now only '1' is possible
    block_type: BlockType.Solution,
    block_details: articles
      // Limit solution list to SEARCH_LIMIT because large list of solutions fails requests as they are sent in a URL
      .slice(-1 * SEARCH_LIMIT)
      .map((article, index) => ({
        support_type: article.articleType || SupportType.Article,
        support_id: article.id,
        support_position: positionStartCount + index + 1, // increment value to start count from 1(not 0)
        output_distance: article?.distance,
      })),
    text,
  };
}
